export class WebhookV1SecurityScan {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "dateCreated",
            "baseName": "dateCreated",
            "type": "WebhookV1ProtobufTimestamp",
            "format": ""
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "WebhookV1ProtobufTimestamp",
            "format": ""
        },
        {
            "name": "conclusion",
            "baseName": "conclusion",
            "type": "WebhookV1ConclusionTypes",
            "format": ""
        },
        {
            "name": "results",
            "baseName": "results",
            "type": "Array<WebhookV1SecurityScanResult>",
            "format": ""
        },
        {
            "name": "approval",
            "baseName": "approval",
            "type": "WebhookV1SecurityScanApproval",
            "format": ""
        },
        {
            "name": "confidenceScore",
            "baseName": "confidence_score",
            "type": "number",
            "format": "float"
        },
        {
            "name": "justification",
            "baseName": "justification",
            "type": "string",
            "format": ""
        },
        {
            "name": "detectorType",
            "baseName": "detector_type",
            "type": "WebhookV1DetectorType",
            "format": ""
        },
        {
            "name": "reviewerType",
            "baseName": "reviewer_type",
            "type": "WebhookV1ReviewerType",
            "format": ""
        },
        {
            "name": "reviewerIsRansomware",
            "baseName": "reviewer_is_ransomware",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "reviewerConfidenceScore",
            "baseName": "reviewer_confidence_score",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "reviewerReason",
            "baseName": "reviewer_reason",
            "type": "string",
            "format": ""
        },
        {
            "name": "reviewerPromptVersion",
            "baseName": "reviewer_prompt_version",
            "type": "string",
            "format": ""
        },
        {
            "name": "riskLevel",
            "baseName": "risk_level",
            "type": "WebhookV1RiskLevel",
            "format": ""
        },
        {
            "name": "riskReason",
            "baseName": "risk_reason",
            "type": "string",
            "format": ""
        },
        {
            "name": "riskModelVersion",
            "baseName": "risk_model_version",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalResultsCount",
            "baseName": "total_results_count",
            "type": "number",
            "format": "int32"
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1SecurityScan.attributeTypeMap;
    }
    constructor() {
    }
}
